import React, { useContext } from 'react'
import { AlertCircle, CheckCircle } from 'react-feather'
import styled, { ThemeContext } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useActiveWeb3React } from '../../hooks'
import { TYPE } from '../../theme'
import { ExternalLink } from '../../theme/components'
import { getEtherscanLink } from '../../utils'
import { AutoColumn } from '../Column'
import { AutoRow } from '../Row'

const RowNoFlex = styled(AutoRow)`
  flex-wrap: nowrap;
`

export default function TransactionPopup({
  hash,
  success,
  summary
}: {
  hash: string
  success?: boolean
  summary?: string
}) {
  const { chainId } = useActiveWeb3React()

  const theme = useContext(ThemeContext)

  const { t } = useTranslation()

  return (
    <RowNoFlex>
      <div style={{ paddingRight: 16,display:'flex' }}>
        {success ? <CheckCircle color={theme.green1} size={41} /> : <AlertCircle color={theme.red1} size={41} />}
      </div>
      <AutoColumn gap="5px">
        <TYPE.body color={theme.text7} fontWeight={500}>{summary ?? 'Hash: ' + hash.slice(0, 8) + '...' + hash.slice(58, 65)}</TYPE.body>
        {chainId && (
          <ExternalLink href={getEtherscanLink(chainId, hash, 'transaction')}>{t('View on Aiascan')}</ExternalLink>
        )}
      </AutoColumn>
    </RowNoFlex>
  )
}
